import React, { ReactElement, useState, useEffect } from "react"
import {
	Box,
	makeStyles,
	Grid,
	InputAdornment,
	TextField,
} from "@material-ui/core"
import orange from "@material-ui/core/colors/orange"
import MoneyInput from "../../MoneyInput"
import Spacer from "../../Spacer"
import { ChangeEvent } from "react"
import useFourQsStyles from "../../HealthCheck/FourQuestions/_config/styles"
import ExpandableNav from "../../ExpandableNav"
import { useFormik } from "formik"
import { BaseCFCStruct } from "../../../data/_config/shape"
import { initialValues } from "."
import formatNumber from "../../../util/formatNumber"

export default function MasterTablePlaning({
	ukupniTroskoviNew,
	ukupniPrihodiNew,
	ukupnoTrajanjeNew,
}: {
	ukupniTroskoviNew?: any
	ukupniPrihodiNew?: any
	ukupnoTrajanjeNew?: any
}): ReactElement {
	const styles = useFourQsStyles()
	const [previousCharges, setPreviousCharges] = useState(0)

	const {
		setFieldValue,
		handleChange,
		values,
		handleSubmit,
	} = useFormik<BaseCFCStruct>({
		initialValues,
		onSubmit: async (formValues: BaseCFCStruct) => {},
	})

	const {
		step1Items,
		step1CalculatedData,
		step2Items,
		step3Items,
		ukupniTroskovi,
		ukupniPrihodi,
		ukupnoTrajanje,
		canvasStartDate,
		step4Items,
		step5Items,
	} = values

	const [ukupniTroskoviPlanirano, setUkupniTroskoviPlanirano] = useState(
		ukupniTroskovi
	)
	const [ukupniPrihodiPlanirano, setUkupniPrihodiPlanirano] = useState(
		ukupniPrihodi
	)
	const [ukupnoTrajanjePlanirano, setUkupnoTrajanjePlanirano] = useState(
		ukupnoTrajanje
	)

	useEffect(() => {
		if (ukupniTroskoviNew) setUkupniTroskoviPlanirano(ukupniTroskoviNew)
	}, [ukupniTroskoviNew])

	useEffect(() => {
		if (ukupniPrihodiNew) setUkupniPrihodiPlanirano(ukupniPrihodiNew)
	}, [ukupniPrihodiNew])

	useEffect(() => {
		if (ukupnoTrajanjeNew) setUkupnoTrajanjePlanirano(ukupnoTrajanjeNew)
	}, [ukupnoTrajanjeNew])

	return (
		<ExpandableNav title="Master tabela" reactourLabel="cfc-four-questions">
			<Box className={styles.box}>
				<Grid item xs={12}>
					<TextField
						value={formatNumber(ukupniTroskoviPlanirano)}
						name="1"
						variant="outlined"
						label="Troškovi"
						disabled={true}
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">€</InputAdornment>
							),
							endAdornment: <InputAdornment position="end"></InputAdornment>,
						}}
					/>
					<Spacer />
					<TextField
						value={formatNumber(ukupniPrihodiPlanirano)}
						name="1"
						variant="outlined"
						label="Prihodi"
						disabled={true}
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">€</InputAdornment>
							),
							endAdornment: <InputAdornment position="end"> </InputAdornment>,
						}}
					/>
					<Spacer />
					<TextField
						value={formatNumber(
							(ukupniPrihodiPlanirano || 0) - (ukupniTroskoviPlanirano || 0)
						)}
						name="1"
						variant="outlined"
						label="Profit"
						disabled={true}
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">€</InputAdornment>
							),
							endAdornment: <InputAdornment position="end"> </InputAdornment>,
						}}
					/>
					<Spacer />
					<TextField
						value={(ukupnoTrajanjePlanirano || 0).toFixed(2)}
						name="1"
						variant="outlined"
						label="Vreme"
						disabled={true}
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">M</InputAdornment>
							),
							endAdornment: <InputAdornment position="end"> </InputAdornment>,
						}}
					/>
				</Grid>
			</Box>
		</ExpandableNav>
	)
}
